import { setupFormulaCalculation } from './formulaEvaluator';

/**
 * Initialize all formula fields in the form
 * Should be called after the form HTML is rendered
 */
export function initializeFormulaFields(containerSelector: string = '.preview-form-content'): void {
  const container = document.querySelector(containerSelector);
  if (!container) {
    console.warn('initializeFormulaFields: Container not found');
    return;
  }

  // Find all inputs with data-formula attribute
  const formulaFields = container.querySelectorAll('input[data-formula]');
  
  console.log(`Initializing ${formulaFields.length} formula fields`);

  formulaFields.forEach((field, index) => {
    if (!(field instanceof HTMLInputElement)) return;

    const formula = field.getAttribute('data-formula');
    const elementId = field.getAttribute('data-element-id');
    if (!formula) return;

    console.log(`[${index + 1}/${formulaFields.length}] Setting up formula for field:`, elementId, 'Formula:', formula);

    // Setup formula calculation with event listeners
    setupFormulaCalculation(field, formula, containerSelector);
  });

  console.log('Formula fields initialized');
}
